var ViewModel = function(value, text) {
    this.value = value;
    this.text = text;
};

export default ViewModel;